import axios from "axios";
import React, { useEffect, useState } from "react";

import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  is_superuser,
  protocol,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
} from "../../Functionalities/Config";
import {
  getToken,
  ManageOrders,
  ManageStatus,
  showMessage,
  ManageRestaurant,
} from "../../Functionalities/Functions";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import RequestListingComponent from "./requestListingComponent";

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [statusArray, setStatusArray] = useState([]);
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");

  const [loading, setLoading] = useState(true);
  const [currenturl, setCurrentUrl] = useState("");

  const [filter, setfilter] = useState({
    id: "FDR",
    status_id: "",
    from_date: "",
    to_date: "",
    payment_mode: "",
    branch_id: "",
    search_text: "",
    delivery_boy_search: "",
  });
  const [statusList, setStatusList] = useState([]);
  useEffect(() => {
    getData();
    getStatus();
  }, []);
  const [reload, setreload] = useState(false);

  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });
  useEffect(() => {
    getBranches();
  }, []);
  useEffect(() => {
    getData();
  }, [reload]);
  useEffect(() => {
    getData();
  }, [statusList]);

  const getBranches = () => {
    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );

    let params = "for_dropdown=true&page_wise=false";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
        setLoading(false);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  let params =
    "id=" +
    filter.id.substr(3) +
    "&status_id=" +
    filter.status_id +
    "&from_date=" +
    filter.from_date +
    "&to_date=" +
    filter.to_date +
    "&payment_mode=" +
    filter.payment_mode +
    "&status_array=" +
    JSON.stringify(statusList) +
    "&branch_id=" +
    filter.branch_id +
    "&search_text=" +
    filter.search_text +
    "&delivery_boy_search=" +
    filter.delivery_boy_search;

  const getData = () => {
    showMessage(
      "Loading orders",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );

    let result = ManageOrders("", "get", "", params);
    result
      .then((result) => {

        setData({
          ...data,
          data: result.data.results,
        });
        setLoading(false);
        setNext(result.data.next);
        setPrev(result.data.previous);
        // setCount(result.data.count)
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };
  const getStatus = () => {
    let statusRes = ManageStatus("", "get", "", "");
    statusRes.then((result) => {
      setStatusArray(result.data);
    });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: { Authorization: getToken() },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
        setCurrentUrl(response.config.url);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handlePrev = () => {
    //alert("prev")
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
        setCurrentUrl(response.config.url);
      })
      .catch(function (error) {});
  };

  return (
    <div>
      <div className="content-body">
        {!loading ? (
          <div className="container-fluid">
            <FilterComponent
              tab={"order"}
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}
              filterButtonName={"Filter"}
              functionFilter={(value, e) => {
                setStatusList([]);
                for (let i = 0; i < value.length; i++) {
                  setStatusList((statusList) => [...statusList, value[i]]);
                }
              }}
            />
            <FilterModalComponent
              heading={"Filter Orders"}
              fromDateValue={filter.from_date.slice(0, 10)}
              fromDateChange={(e) => {
                setfilter({
                  ...filter,
                  from_date: e.target.value + " 00:00:00",
                });
              }}
              toDateValue={filter.to_date.slice(0, 10)}
              toDateChange={(e) => {
                setfilter({
                  ...filter,
                  to_date: e.target.value + " 00:00:00",
                });
              }}
              clearFilter={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              submitFilter={(e) => {
                e.preventDefault();
                getData();
              }}
            >
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Order ID <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Order Id"
                      value={filter.id}
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          id: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Status <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <select
                      value={filter.status_id}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          status_id: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>

                      {statusArray.map((item) => (
                        <option value={item.id} id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Payment Mode <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <select
                      value={filter.payment_mode}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          payment_mode: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      <option value={"COD"} id={"COD"}>
                        Cash On Delivery
                      </option>
                      <option value={"ONLINE"} id={"ONLINE"}>
                        Online Payment
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              {(is_superuser ||
                is_franchise_admin ||
                is_franchise_manager ||
                is_franchise_staff) && (
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Restaurant <span className="required"></span>
                    </label>
                    <select
                      value={filter.branch_id}
                      class="form-control form-control-lg"
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          branch_id: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      {restrarent?.data?.map((item) => (
                        <option value={item.id} id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Search User <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={filter.search_text}
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          search_text: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Search Deliveryboy <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={filter.delivery_boy_search}
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          delivery_boy_search: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </FilterModalComponent>

            <div className="row mt=2">
              <div className="col-lg-12">
                <div className="table-responsive rounded card-table">
                  <div
                    id="example5_wrapper"
                    class="dataTables_wrapper no-footer"
                  >
                    <table
                      className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                      id="example5"
                    >
                      <thead>
                        <tr>
                          <th>REQUESTED FRANCHISE </th>
                          <th>USER</th>

                          {/* <th>DATE</th> */}
                          <th>AMOUNT</th>
                          <th>REASON</th>
                        </tr>
                      </thead>
                      <>
                        <RequestListingComponent />
                      </>
                    </table>

                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="example5_paginate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function FranchiseRequest() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Franchise Request"}
          subHeading={"All Orders under foodoor"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default FranchiseRequest;
